import { heroStats } from '@/mocks/homeData';

const HERO_COVER =
  'https://readdy.ai/api/search-image?query=top%20down%20view%20of%20an%20evidence%20dossier%20on%20a%20warm%20wooden%20desk%20stack%20of%20printed%20documents%20with%20black%20redaction%20bars%20handwritten%20margin%20notes%20and%20a%20red%20round%20stamp%20seal%20on%20the%20paper%20an%20ink%20pen%20and%20paperclip%20editorial%20documentary%20photography%20soft%20warm%20desk%20light%20cream%20and%20amber%20tones%20high%20detail%20realistic%20texture%20no%20people&width=1000&height=1250&seq=home-hero-cover&orientation=portrait';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-24 pb-10 md:pt-28 md:pb-16">
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -left-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-12">
        {/* 左：文案 */}
        <div className="flex flex-col justify-center lg:col-span-6">
          <div className="inline-flex items-center gap-2 self-start rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            今日档案 · 持续核验更新中
          </div>

          <h2 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            每一句「实锤」，
            <br />
            背后都有<span className="text-primary-600">可查的材料</span>。
          </h2>

          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
            文件曝光、录音证据、合同截图、转账记录、邮件往来——今日爆料把散落在各处的原始材料逐一留档。
            不玩虚的，只做三件事：收进来、核得清、放得开。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#zui-xin"
              className="flex h-11 items-center justify-center rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 whitespace-nowrap transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
            >
              查看最新实锤
              <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
            </a>
            <a
              href="#lei-xing"
              className="flex h-11 items-center justify-center rounded-md border border-foreground-200 bg-background-50 px-6 text-sm font-medium text-foreground-900 whitespace-nowrap transition-colors duration-200 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
            >
              浏览五大证据品类
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-200 pt-6 sm:grid-cols-4">
            {heroStats.map((s) => (
              <div key={s.label}>
                <div className="font-heading text-2xl font-black text-foreground-950">{s.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 右：封面对开图 */}
        <div className="lg:col-span-6">
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <div className="absolute -top-3 -right-2 z-10 flex rotate-6 items-center gap-1.5 rounded-md bg-accent-500 px-3 py-1.5 text-sm font-bold text-foreground-950">
              <i className="ri-check-double-line" aria-hidden="true"></i>
              今日已核 12 件
            </div>
            <div className="absolute -left-2 top-8 z-10 hidden -rotate-3 items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50 sm:flex">
              <i className="ri-lock-2-line" aria-hidden="true"></i>
              原件已留档
            </div>

            <div className="relative overflow-hidden rounded-lg">
              <div className="aspect-[4/5] w-full">
                <img
                  src={HERO_COVER}
                  alt="今日爆料证据档案原始材料"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent px-5 pb-5 pt-16">
                <p className="font-heading text-sm font-bold text-background-50">档案库 · 2026 第 328 号</p>
                <p className="mt-1 text-xs leading-relaxed text-background-200/90">
                  原始文件、转写稿、比对记录同批归档，留档路径全程可追溯。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}